import(/* webpackMode: "eager", webpackExports: ["RestaurantMenu"] */ "/app/src/components/restaurant/RestaurantMenu.tsx");
